import React from 'react';
import { useTranslation } from 'react-i18next';
import LinkedInCard from './LinkedInCard';

const inputClass =
  'w-full rounded-lg border border-white/10 bg-white/[0.06] px-3 py-2.5 text-sm text-white placeholder:text-gray-400 outline-none backdrop-blur-sm transition focus:border-white/20 focus:ring-2 focus:ring-blue-500/40';

const fieldLabelClass =
  'mb-2 block text-[10px] font-semibold uppercase tracking-wide text-white/45 sm:text-[11px]';

export function Contatos() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-1 flex-col">
      <div className="flex flex-1 flex-col items-center justify-center gap-8 bg-gray-800 px-4 py-10 sm:px-6 md:gap-10 md:py-14 lg:gap-12 lg:px-8 lg:py-16">
        <div className="mx-auto grid w-full max-w-screen-2xl flex-1 grid-cols-1 gap-8 md:grid-cols-2 md:items-stretch md:gap-10 lg:gap-12 lg:min-h-[min(48vh,520px)]">
          <div className="flex h-full min-h-0 w-full min-w-0 flex-col">
            <LinkedInCard />
          </div>

          <div className="relative flex h-full min-h-0 w-full min-w-0 flex-col overflow-hidden rounded-3xl">
            <div className="relative flex h-full min-h-0 flex-1 flex-col px-4 pb-6 pt-5 sm:px-6 sm:pb-7 sm:pt-6">
              <h2 className="mb-4 shrink-0 text-center text-lg font-semibold tracking-wide text-white/95 lg:mb-5">
                {t('contato.gmail')}
              </h2>

              <div className="flex min-h-0 flex-1 flex-col rounded-3xl border border-white/15 bg-white/[0.07] p-1 shadow-lg shadow-blue-500/10 backdrop-blur-xl">
                <form
                  method="POST"
                  action="https://formsubmit.co/laert.ff@gmail.com"
                  className="flex min-h-0 flex-1 flex-col"
                >
                  <input
                    type="hidden"
                    name="_next"
                    value="https://laert-furquin.vercel.app/#/agradecimento"
                  />

                  <div className="shrink-0 rounded-2xl border border-white/10 bg-white/[0.06] p-4 backdrop-blur-md sm:p-5 md:p-6">
                    <div className="space-y-4 sm:space-y-5">
                      <div>
                        <label className={fieldLabelClass} htmlFor="contato-nome">
                          {t('contato.seuNome')}
                        </label>
                        <input
                          id="contato-nome"
                          className={inputClass}
                          type="text"
                          name="name"
                          placeholder={t('contato.seuNomePlaceholder')}
                          required
                          autoComplete="name"
                        />
                      </div>
                      <div>
                        <label className={fieldLabelClass} htmlFor="contato-email">
                          {t('contato.seuEmail')}
                        </label>
                        <input
                          id="contato-email"
                          className={inputClass}
                          type="email"
                          name="email"
                          placeholder={t('contato.seuEmailPlaceholder')}
                          required
                          autoComplete="email"
                        />
                      </div>
                      <div>
                        <label className={fieldLabelClass} htmlFor="contato-assunto">
                          {t('contato.assunto')}
                        </label>
                        <input
                          id="contato-assunto"
                          className={inputClass}
                          type="text"
                          name="subject"
                          placeholder={t('contato.assuntoPlaceholder')}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="flex min-h-0 flex-1 flex-col justify-start border-t border-white/10 px-4 py-5 sm:px-5">
                    <label className={fieldLabelClass} htmlFor="contato-mensagem">
                      {t('contato.escrevaAqui')}
                    </label>
                    <textarea
                      id="contato-mensagem"
                      className={`${inputClass} mt-2 min-h-[120px] flex-1 resize-y leading-relaxed sm:min-h-[140px]`}
                      name="message"
                      placeholder={t('contato.mensagemPlaceholder')}
                      required
                      rows={5}
                    />
                  </div>

                  <div className="mt-auto shrink-0 px-4 pb-5 pt-2 sm:px-5">
                    <button
                      type="submit"
                      className="flex w-full items-center justify-center rounded-xl bg-white py-3 text-center text-xs font-bold uppercase tracking-wide text-blue-600 shadow-[0_8px_32px_-8px_rgba(59,130,246,0.55)] transition hover:bg-white/95 hover:text-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-400 sm:py-3.5 sm:text-sm"
                    >
                      {t('contato.enviar')}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contatos;
